import React, {useContext, useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import {Container, Typography} from '@material-ui/core';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import {uiConfig} from './firebase';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// import {Link} from 'react-router-dom';
import {AuthContext} from 'context/AuthContext';
import {UserContext} from 'context/UserContext';
import LoadingPage from 'components/LoadingPage';
import useBrowserTitle from 'hooks/useBrowserTitle';
import {Helmet} from 'react-helmet';
import Show from 'components/utils/Show';
import {useFlags} from 'hooks';

const SignIn = ({referral, register, ...props}) => {
    const {sign_in_options} = useFlags();
    const {isAuthenticated, isLoading} = useContext(AuthContext);
    const {isUserLoading, userState} = useContext(UserContext);
    const firebaseConfig = uiConfig(register || referral, sign_in_options);
    const [referralCode, setReferralCode] = useState(null);
    const headerText = referral
        ? 'Get Started With A Free Month!'
        : 'Sign In to MM-SEAS';

    useBrowserTitle(referral ? '| Get Started!' : '| Sign In');

    useEffect(() => {
        window.location.search
            .substring(1)
            .split('&')
            .forEach(param => {
                const [name, value] = param.split('=');
                if (name.toLocaleLowerCase() === 'code') {
                    window.sessionStorage.setItem('REFERRAL_CODE', value);
                    setReferralCode(value);
                }
            });
        // eslint-disable-next-line
    }, []);

    if (isLoading || isUserLoading) {
        return <LoadingPage />;
    } else if (isAuthenticated) {
        return <Redirect to='/home' />;
    } else {
        return [
            <Helmet>
                <meta
                    property='og:title'
                    content='Merchant Mariner Secure Electronic Application Software'
                />
                <meta
                    property='og:description'
                    content={`I found MM-SEAS and it has made USCG Licensing so much easier! It’s software that is actually built for mariners to help mariners! When you use my referral code you get a free month and I get a free month!
`}
                />
            </Helmet>,
            <Container maxWidth='sm'>
                <Show condition={userState === 'emailNotVerified'}>
                    <Redirect to='/verify-email' />
                </Show>
                <div style={{minHeight: '40px'}} />
                <Typography variant='h4' align='center'>
                    {headerText}
                </Typography>
                <Typography variant='h6' align='center'>
                    {referral ? (
                        <div>
                            You're also helping your friend out by using their code:{' '}
                            <p
                                style={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                }}
                            >
                                {referralCode}
                            </p>
                            Choose an option below to setup your account
                        </div>
                    ) : (
                        `If this is your first time, select an option below to create
                    your account and start your free 14 day trial with MM-SEAS`
                    )}
                </Typography>
                <div style={{minHeight: '40px'}} />
                <StyledFirebaseAuth
                    uiConfig={firebaseConfig}
                    firebaseAuth={firebase.auth()}
                />
                <div style={{minHeight: '30px'}} />
            </Container>,
        ];
    }
};
export default SignIn;
